<template>
	<div class="z-box-wrap">
		<ul class="head">
			<li :class="{active:activeIndex==0}" @click="activeIndex = 0">待审核{{ `(${waitNum})` }}</li>
			<li :class="{active:activeIndex==1}" @click="activeIndex = 1">已审核</li>
		</ul>
	
		<div class="main">
			<!-- 待审核 -->
			<div class="tab-div" v-show="activeIndex == 0">
				<div class="search-head">
					<span>申请类型：</span>
					<el-select class="top-choose" v-model="wait_typeId" clearable placeholder="请选择">
						<el-option v-for="item in typeOptions" :key="item.id" :value="item.id" :label="item.label">
						</el-option>
					</el-select>
					<span>申请时间：</span>
					<el-date-picker class="top-choose" v-model="wait_datePick_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="wait_datePick_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<div class='front-btn green shift'  @click="search()">查询</div>
				</div>

				<div class="list">
					<div class="list-head">
						<div>申请时间
							<div class="angle-wrap">
								<i class="el-icon-caret-top" :class="{active:wait_sort == 'createdAt_asc'}" @click="SortSearch('createdAt_asc')"></i>
								<i class="el-icon-caret-bottom" :class="{active:wait_sort == 'createdAt_desc'}" @click="SortSearch('createdAt_desc')"></i>
							</div>
						</div>
						<div>申请类型</div>
						<div>状态</div>
						<div>操作</div>
					</div>	
					<z-scrollDiv class="list-detail">
						<div class="item" v-for="item in waitList" :key="item.id">
							<div>{{ item.created_at }}</div>
							<div>{{	typeObj[item.req_type].str || "未知类型" }}</div>
							<div>{{ StatusStr(item.status) }}</div>
							<div @click="showSlider(item)">详情</div>
						</div>
						<z-noData :list="waitList"></z-noData>
					</z-scrollDiv>	
				</div>

				<z-pagination class="inside" @getPage="search" :data='wait_data'></z-pagination>
			</div>

			<!-- 已审核 -->
			<div class="tab-div" v-show="activeIndex == 1">
				<div class="search-head">
					<span>申请类型：</span>
					<el-select class="top-choose" v-model="deal_typeId" clearable placeholder="请选择">
						<el-option v-for="item in typeOptions" :key="item.id" :value="item.id" :label="item.label">
						</el-option>
					</el-select>
					<span>申请时间：</span>
					<el-date-picker class="top-choose" v-model="deal_datePick_start" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<small>~</small>
					<el-date-picker class="top-choose" v-model="deal_datePick_end" type="date" placeholder="选择日期" :picker-options="picker_special">
					</el-date-picker>
					<div class='front-btn green shift'  @click="search()">查询</div>
				</div>

				<div class="list">
					<div class="list-head">
						<div>申请时间
							<div class="angle-wrap">
								<i class="el-icon-caret-top" :class="{active:deal_sort == 'createdAt_asc'}" @click="SortSearch('createdAt_asc')"></i>
								<i class="el-icon-caret-bottom" :class="{active:deal_sort == 'createdAt_desc'}" @click="SortSearch('createdAt_desc')"></i>
							</div>
						</div>
						<div>申请类型</div>
						<div>状态</div>
						<div>审核时间</div>
						<div>操作</div>
					</div>

					<z-scrollDiv class="list-detail">
						<div class="item" v-for="item in dealList" :key="item.id">
							<div>{{ item.created_at }}</div>
							<div>{{	typeObj[item.req_type].str || "未知类型" }}</div>
							<div  :class="{red:item.status==3}">{{ StatusStr(item.status) }}</div>
							<div>{{ item.updated_at }}</div>
							<div @click="showSlider(item)">{{ item.status==3?"处理":"详情" }}</div>
						</div>
						<z-noData :list="dealList"></z-noData>
					</z-scrollDiv>

				</div>

				<z-pagination class="inside" @getPage="search" :data='deal_data'></z-pagination>
			</div>
		</div>

		<!-- 滑页 -->
		<sliderPage :title="sliderTitle" :sliderArg="sliderArg">
			<sliderBudget v-show="sliderTitle=='预算申请'" :data="slider_data" :resub="resub" @refresh="allFresh"></sliderBudget>
			<sliderDelay v-show="sliderTitle=='延期申请'" :data="slider_data" :resub="resub" @refresh="allFresh"></sliderDelay>
			<sliderAdd v-show="sliderTitle=='增岗申请'" :data="slider_data" :resub="resub" @refresh="allFresh"></sliderAdd>
			<sliderMod v-show="sliderTitle=='调岗申请'" :data="slider_data" :resub="resub" @refresh="allFresh"></sliderMod>
		</sliderPage>
	</div>
</template>

<script>
	import sliderPage from "src/components/slider/sliderPage.vue"
	import sliderBudget from "src/components/slider/sliderBudget.vue"
	import sliderDelay from "src/components/slider/sliderDelay.vue"
	import sliderAdd from "src/components/slider/sliderAdd.vue"
	import sliderMod from "src/components/slider/sliderMod.vue"


	import { mapState } from "vuex";


	export default {
		components: {
			sliderPage,
			sliderBudget,
			sliderDelay,
			sliderAdd,
			sliderMod,
		},
		data() {
			return {
				activeIndex: 0,  //tab 序号
				waitNum:0,   //待审核数量
				typeObj:{
					1:{str:"预算申请",url:"api/manager/curr_bgt_req/"}, 
					2:{str:"延期申请",url:"api/manager/curr_trans_req/"}, 
					3:{str:"增岗申请",url:"api/manager/new_position_req/"}, 
					4:{str:"调岗申请",url:"api/manager/transfer_position_req/"}, 
				},
				sliderArg:{
					flag:false,
					inside_index:0,
					insideFlag:false,
				},
				slider_data:{},
				sliderTitle:"",

				resub:{
					// budget_typeId:"",  //预算申请 快币类型
					budget_amount:"",  //预算申请 快币金额
					budget_reason:"",  //预算申请 申请理由

					delay_reason:"",  //延期申请 申请理由 

					add_positionId:"",  //增岗申请  岗位id
					add_typeId:"", // 增岗申请 增岗类型
					add_num:"", //增岗申请 增岗人数
					add_require:"",  //增岗申请  岗位需求
					add_reason:"",  //增岗申请 申请理由

					mod_typeId:"", // 调岗申请 调岗类型
					mod_changeIds:[], //调岗申请 人员id 
					mod_reason:"",  //调岗申请 理由
				},

				
				wait_data:{},   //待处理 数据
				wait_typeId: "",   //待处理 类型id
				wait_datePick_start: "", //待处理 开始时间
				wait_datePick_end: "",  //待处理 终止时间、
				wait_sort:"createdAt_desc",

				deal_data:{},   //待处理 数据
				deal_typeId: "",   //待处理 类型id
				deal_datePick_start: "", //待处理 开始时间
				deal_datePick_end: "",  //待处理 终止时间
				deal_sort:"createdAt_desc",
			}
		},

		computed:{
			...mapState(["picker_special"]),

			req_status(){  //请求的状态
				return this.activeIndex==0?1:5;
			},  
			req_type(){  //请求的类型
				return this.activeIndex==0?this.wait_typeId:this.deal_typeId;
			},
			req_start(){  //请求的起始时间
				return this.activeIndex == 0?this.wait_datePick_start:this.deal_datePick_start;
			},
			req_end(){   //请求的结束时间
				return this.activeIndex == 0?this.wait_datePick_end:this.deal_datePick_end;
			},
			req_sort:{  //请求的排序方式
				get(){
					return this.activeIndex == 0?this.wait_sort:this.deal_sort;
				},
				set(val){
					if(val == ""){
						this.wait_sort = "createdAt_desc";
						this.deal_sort = "createdAt_desc";
					}else if ( val == "createdAt_desc" || val == "createdAt_asc" ){
						this.activeIndex == 0?(this.wait_sort = val):(this.deal_sort = val);
					}
				},
			},

			typeOptions(){  //类型选项
				let res = [];
				for(var i in this.typeObj){
					res.push({
						id:i,
						label:this.typeObj[i].str
					})
				}
				return res;
			},

			waitList(){  //待审核数据
				return this.wait_data.list;
			},
			dealList(){  //已审核数据
				return this.deal_data.list;
			},
		},
		watch:{
			"sliderArg.flag"(val){
				if(val == false){
					this.slider_data = {};
					for(let i in this.resub){
						this.resub[i] = "";
					}
				}
			}
			
		},

		created(){
			this.allFresh();
		},

		methods: {
			allFresh(){
				this.sliderArg.flag = false;
				this.refresh({status:1},function(){
					this.waitNum = this.wait_data.total;
				});

				this.refresh({status:5});
			},

			StatusStr(status){  //拼接状态字符串
				let obj = {
					1:"待处理",
					2:"审核成功",
					3:"审核失败",
					5:"已处理",
				}
				return obj[status] || "没有哦";
			},
			refresh(obj = {},func){  //拉取数据
				if(typeof obj == "function"){
					func = obj;
					obj = {};
				}

				let url = "api/manager/req_detail";
				let config = {params:obj};
				this.$http.get(url,config).then(res=>{
					if(res.status == 200){
						if(obj.status == 1){
							this.wait_data = res.res_data;
						}else{
							this.deal_data = res.res_data;
						}
						func && func.apply(this);
					}
				});
			},
			search(page){   //查询数据
				let obj = {
					page:page,
					status:this.req_status,
					req_type:this.req_type,
					start_date:this.req_start,
					end_date:this.req_end,
					order_str:this.req_sort,
				}
				this.refresh(obj);
			},
			SortSearch(str){  //排序
				this.req_sort = str;//createdAt_desc
				this.search();
			},

			// ******滑页交互**************
			showSlider(item){
				this.sliderTitle = this.typeObj[item.req_type].str;
				this.sliderArg.flag = true;

				let url = this.typeObj[item.req_type].url + item.req_id;
				this.$http.get(url).then(res=>{
					if(res.status == 200){
						this.slider_data = res.res_data;
					}
				});
			}


		}
	}
</script>

<style lang="less" scoped>
	@import "~src/assets/less/var.less";
	@import "~src/assets/less/application.less";

	.list-head >div,.list-detail .item>div{
        &:nth-of-type(1){
            width: 15%;
        }
        &:nth-of-type(2){
            width: 15%;
        }
        &:nth-of-type(3){
            width: 15%;
		}
		&:nth-of-type(4){
            width: 15%;
		}
	}

	.list-detail .item>div{
		&:last-of-type{
			color: @focus-c;
			cursor:pointer;
		}
	}

	.z-box-wrap{
		// height: calc(~"100% - 60px - 40px");  //减去头部高 margin
		// margin: @front_padd;
	}

	.red{
		color:@red;
	}
</style>





// WEBPACK FOOTER //
// page-my-application.vue?ba5811ac